import { render, staticRenderFns } from "./RetailShop.vue?vue&type=template&id=086958f9&scoped=true"
import script from "./RetailShop.vue?vue&type=script&lang=js"
export * from "./RetailShop.vue?vue&type=script&lang=js"
import style0 from "./RetailShop.vue?vue&type=style&index=0&id=086958f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086958f9",
  null
  
)

export default component.exports